import cx from 'classnames';
import React from 'react';
import styles from './divider.module.scss';
export const Divider = ({ className, vertical, includeSectionBorder = true, ...restProps }) => (React.createElement("div", { className: cx(className, {
        [styles.includeSectionBorder]: includeSectionBorder,
        [styles.vertical]: vertical,
    }), ...restProps }));
//# sourceMappingURL=divider.js.map